// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_PEf","cls2":"ReferenceCard-cls2_V_a ReferenceCard-cls1_PEf","expanded":"ReferenceCard-expanded_WR3"};